import {
	HttpInterceptor,
} from 'utils/http';
import {
	database,
} from 'utils/database';
import {
	SettingKey,
} from 'utils/database/enums/setting-key.enum';
import {
	SessionToken,
} from 'models/authorization/session-token.model';
import {
	Setting,
} from 'models/setting.model';
import {
	contains,
} from 'utils/text';

export const authInterceptor: HttpInterceptor<RequestInit> =
  async (url: string, request: RequestInit): Promise<RequestInit> => {
  	if (contains(url, ['localhost', 'tradesolution.no'])) {
  		try {
  			const token: Setting<SessionToken> | undefined = await database.settings.get(SettingKey.SESSION);
  			if (token?.value?.accessToken) {
  				return {
  					...request,
  					headers: {
  						...request.headers,
  						'Authorization': `Bearer ${token?.value?.accessToken}`,
  					},
  				}
  			}
  			return request;
  		}
  		catch (e) {
  			return request;
  		}
  	}
  	return request;
  };